import wretch from 'wretch';

import { LearningCoreRestCRUDService } from '../common/LearningCoreRestCRUDService';
import { IPracticeAnswerSubmission, IQuizAnswerSubmission, IUnitResultModel } from './IUnitResultModel';
import { IUnitResultService } from './IUnitResultService';

wretch().errorType('json');

export class RestUnitResultService extends LearningCoreRestCRUDService<IUnitResultModel> implements IUnitResultService {
  createFirstData(unitId: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
  
  getEndpoint(): string {
    const url = this.learningConfig.url.api.learning;
    return `${url}/unitResult`;
  }

  async passTheory(body: { unitResultId: string }): Promise<void> {
    await this.request()
      .url(`${this.getEndpoint()}/theory/pass`)
      .post(body)
      .json<{ state: string; id: string }>()
      .catch(this.handleError);
  }

  async passQuiz(body: { unitId: string, questions: IQuizAnswerSubmission[] }): Promise<void> {
    await this.request()
      .url(`${this.getEndpoint()}/quiz/pass`)
      .post(body)
      .json<{ state: string; id: string }>()
      .catch(this.handleError);
  }

  async passPractice(body: { unitId: string, tasks: IPracticeAnswerSubmission[]; pickedLang: string }): Promise<void> {
    await this.request()
      .url(`${this.getEndpoint()}/practice/pass`)
      .post(body)
      .json<{ state: string; id: string }>()
      .catch(this.handleError);
  }

  async finishUnit(body: { unitResultId: string }): Promise<void> {
    await this.request()
      .url(`${this.getEndpoint()}/finish/unit`)
      .post(body)
      .json<{ state: string, id: string }>()
      .catch(this.handleError)
  }

  async getPassingUnitResultData(unitId: string): Promise<IUnitResultModel | null> {
    const searchResult = await this.request()
      .url(`${this.getEndpoint()}/units/${unitId}/passing`)
      .post()
      .res()
      .catch(this.handleError);


    const searchResultText = await searchResult.text();

    if (!searchResultText) {
      return null;
    }

    return JSON.parse(searchResultText, this.dateTimeReviver);
  }


}
